import { getCategoryHref } from '../../utils/common/category';
import { INTRODUCTION_PARAGRAPH_GENERATOR_CATEGORY } from '../../constants';

import { chipValues } from './shared';

const data = [
  {
    type: 'chips',
    properties: {
      isAdvanced: false,
      name: 'paragraphGeneratorType',
      analyticsName: 'paragraph_type',
      textLabel: 'Generate paragraph for...',
      hasErrorValidation: false,
      warningMessage: null,
      selectedCategory: INTRODUCTION_PARAGRAPH_GENERATOR_CATEGORY,
      required: false,
      flex: '100%',
      information: null,
      chipValues,
      defaultChipValue: {
        title: 'All',
        value: getCategoryHref(INTRODUCTION_PARAGRAPH_GENERATOR_CATEGORY),
      },
    },
  },
  {
    type: 'input',
    properties: {
      name: 'paragraphGeneratorTopic',
      isAdvanced: false,
      flex: '100%',
      analyticsName: 'paragraph_generator_topic',
      textLabel: 'Describe the topic of your paragraph',
      placeholder: 'E.g., "benefits of using an AI paragraph generator vs. manually writing it"',
      hasErrorValidation: true,
      warningMessage: null,
      information: null,
      selectedCategory: INTRODUCTION_PARAGRAPH_GENERATOR_CATEGORY,
      isOptional: false,
      required: true,
      tooltipProps: null,
    },
  },
  {
    type: 'input',
    properties: {
      name: 'paragraphGeneratorDetails',
      isAdvanced: false,
      flex: '100%',
      analyticsName: 'paragraph_generator_details',
      textLabel: 'Include the following details',
      placeholder: 'E.g., company/brand/product name',
      hasErrorValidation: true,
      warningMessage: null,
      information: null,
      isOptional: true,
      selectedCategory: INTRODUCTION_PARAGRAPH_GENERATOR_CATEGORY,
      required: false,
      tooltipProps: null,
    },
  },
  {
    type: 'dropdown',
    properties: {
      information: null,
      name: 'length',
      isAdvanced: false,
      flex: 'calc(50% -  24px)',
      analyticsName: 'length',
      textLabel: 'Choose length',
      isOptional: true,
      hasErrorValidation: false,
      warningMessage: null,
      selectedCategory: 19,
      required: false,
      dropdownValues: [
        {
          title: 'Short',
          value: 'short',
        },
        {
          title: 'Medium',
          value: 'medium',
        },
        {
          title: 'Long',
          value: 'long',
        },
      ],
    },
  },
  {
    type: 'dropdown',
    properties: {
      name: 'tone',
      isAdvanced: false,
      information: null,
      flex: 'calc(50% -  24px)',
      analyticsName: 'tone',
      textLabel: 'Choose a tone',
      hasErrorValidation: false,
      warningMessage: null,
      selectedCategory: 0,
      required: false,
      labelPaddingTop: 12,
      labelPaddingTopMobile: 0,
      dropdownValues: [
        {
          title: '😊 Friendly',
          value: 'friendly',
        },
        {
          title: '💎 Luxury',
          value: 'luxury',
        },
        {
          title: '😌 Relaxed',
          value: 'relaxed',
        },
        {
          title: '💼 Professional',
          value: 'professional',
        },
        {
          title: '💪 Bold',
          value: 'bold',
        },
        {
          title: '⛺ Adventurous',
          value: 'adventurous',
        },
        {
          title: '💡 Witty',
          value: 'witty',
        },
        {
          title: '🧠 Persuasive',
          value: 'persuasive',
        },
        {
          title: '😍 Empathetic',
          value: 'empathetic',
        },
      ],
    },
  },
];

export default data;
